import {Map, List} from 'immutable'
import _ from 'lodash'

const getFAQs = (state) => state.getIn(['faq', 'items']);

const getFAQByCategoriesId = (state, id) => {
    let items = state.getIn(['faq', 'items'])
    return items.filter((item)=>{
            if(id < 1)
                return !item.get('category_id')
            return item.get('category_id') === id
    })
}

const getFAQById= (state, id) => state.getIn(['faq', 'items', String(id)], Map())
const getCurrentPayload = (state) => state.getIn(['faq', 'currentPayload'], null);

const getAnswer = (faq) => faq.get('answer', '');
const getQuestion = (faq) => faq.get('question', '');
const getDateCreated = (faq) => faq.get('date_created', '');
const getDateModified = (faq) => faq.get('date_modified', '');
const getAuthorName = (faq) => faq.get('author_name', '');
const getAuthorImg = (faq) => faq.get('author_img', '');
const getId = (faq) => faq.get('id');
const getCurrentItem = (state) => state.getIn(['faq', 'current'], null)
const getCategories = (state)=> state.getIn(['faq', 'categories'], List())
const getVisibleItems = (categories) => _.filter(categories, function(o) {return o.visible})
const get = (state, name) => {
    switch(name){
        case 'categories':
            return getCategories(state)
        default:
            return Map()
    }
}

export {
    getFAQs, getCategories, getFAQByCategoriesId, getFAQById, getAnswer,
    getQuestion, getDateCreated, getDateModified, getAuthorImg, getAuthorName,
    getId, getCurrentItem, getVisibleItems, getCurrentPayload
}
export default get



// WEBPACK FOOTER //
// ./src/model/FAQ/selector.js